export const breakpoints = {
  tablet: '768px',
  desktop: '1200px',
} as const;
